import { render, staticRenderFns } from "./attachFile.vue?vue&type=template&id=07979bbb&scoped=true&"
import script from "./attachFile.vue?vue&type=script&lang=js&"
export * from "./attachFile.vue?vue&type=script&lang=js&"
import style0 from "./attachFile.vue?vue&type=style&index=0&id=07979bbb&prod&scoped=true&lang=scss&"
import style1 from "./attachFile.vue?vue&type=style&index=1&id=07979bbb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07979bbb",
  null
  
)

export default component.exports